<template>
  <div class="flex w-screen justify-center">
    <div v-if="is404" class="flex flex-col items-center p-6">
      <h1 class="mt-48 text-9xl font-black">404</h1>
      <p class="mt-6 w-full text-lg">Pagina kon niet worden gevonden</p>
      <a class="mt-4 text-lg underline" href="/">Terug naar homepage</a>
    </div>
    <div v-else class="flex flex-col items-center p-6">
      <h1 class="mt-48 text-9xl font-black">500</h1>
      <p class="mt-6 w-full text-lg">
        Er is iets fout gegaan. Probeer het later opnieuw.
      </p>
      <a class="mt-4 text-lg underline" href="/">Terug naar homepage</a>
    </div>
  </div>
</template>

<script setup>
defineProps(['is404'])
</script>
